import { buscaetiqueta } from './buscaEtiquetaXML'

function splitPath(p) {
  return p.split('.')
}
function isArraySeg(s) {
  return s.endsWith('[]')
}
function cleanSeg(s) {
  return isArraySeg(s) ? s.slice(0, -2) : s
}

function countArrays(parts) {
  let n = 0
  for (const seg of parts) if (isArraySeg(seg)) n++
  return n
}
function firstArrayPos(parts) {
  for (let i = 0; i < parts.length; i++) if (isArraySeg(parts[i])) return i
  return -1
}
function firstSpine(parts) {
  // padre = hasta la PRIMERA [] (incluida)
  const p = firstArrayPos(parts)
  return p === -1 ? null : parts.slice(0, p + 1)
}
function arraysEqual(a, b) {
  if (!a || !b) return false
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false
  return true
}

// Resuelve paths (acepta índices numéricos como segmentos)
function resolvePath(obj, parts) {
  return parts.reduce((acc, seg) => {
    if (acc == null) return undefined
    if (Array.isArray(acc) && /^\d+$/.test(seg)) return acc[+seg]
    return acc[seg]
  }, obj)
}

// Extrae todos los ${fori:...} de un bloque de fila
function analyzeRowForis(rowXml) {
  const out = []
  const re = /\$\{fori:([^\}]+)\}/g
  let m
  while ((m = re.exec(rowXml))) {
    const raw = m[1]
    const parts = splitPath(raw)
    out.push({
      raw,
      parts,
      depth: countArrays(parts),
      firstSpine: firstSpine(parts), // espina externa (PADRE)
    })
  }
  //console.log('Foris encontrados:', out)
  return out
}

// Lista todas las filas <w:tr>…</w:tr> como rangos + xml
function listRows(xml) {
  const rows = []
  let pos = 0
  while (true) {
    const rng = buscaetiqueta(xml, pos, 'w:tr')
    if (!rng) break
    rows.push({ start: rng.start, end: rng.end, xml: xml.slice(rng.start, rng.end) })
    pos = rng.end
  }
  //console.log('Filas encontradas:', rows)
  return rows
}

// Convierte ${fori:...} → ${v:...} rellenando las primeras N ocurrencias de [] con índices dados
function replaceForiWithIndices(rowXml, indices /* ej [i] o [i,j] */) {
  return rowXml.replace(/\$\{fori:([^\}]+)\}/g, (_m, raw) => {
    const parts = splitPath(raw)
    let k = 0
    const mapped = parts.map((seg) => {
      if (isArraySeg(seg)) {
        const base = cleanSeg(seg)
        const idx = indices[k++]
        return idx == null ? `${base}[]` : `${base}[${idx}]`
      }
      return seg
    })
    return '${v:' + mapped.join('.') + '}'
  })
}

// Dado un path con >= 2 [], devuelve info de la segunda [] relativa al padre
function childArrayInfo(parts) {
  const p1 = firstArrayPos(parts)
  if (p1 === -1) return null
  for (let i = p1 + 1; i < parts.length; i++) {
    if (isArraySeg(parts[i])) {
      return {
        secondIdx: i,
        between: parts.slice(p1 + 1, i), // segmentos entre padre[] y segundo []
        childKey: cleanSeg(parts[i]), // nombre del array hijo
      }
    }
  }
  return null
}

// Resuelve el array hijo dentro del contexto del padre[i]
function resolveChildArray(baseContext, between, childKey) {
  let cur = baseContext
  for (const seg of between) {
    if (cur == null) return undefined
    if (Array.isArray(cur) && /^\d+$/.test(seg)) cur = cur[+seg]
    else cur = cur[seg]
  }
  return cur ? cur[childKey] : undefined
}

export function expandFori(xmlString, data) {
  let xml = xmlString

  // 1) Listar filas
  const rows = listRows(xml)
  if (!rows.length) return xml

  // 2) Analizar foris por fila
  for (const r of rows) r.foris = analyzeRowForis(r.xml)

  // 3) Construir salida
  let out = ''
  let cursor = 0

  // Utilidad: get array base (padre) para una espina externa
  function baseArrayFor(spineParts) {
    if (!spineParts) return null
    const baseParent = resolvePath(data, spineParts.slice(0, -1)) // sin la []
    const baseKey = cleanSeg(spineParts[spineParts.length - 1])
    const arr = baseParent ? baseParent[baseKey] : undefined
    return Array.isArray(arr) ? arr : null
  }

  // ¿La fila pertenece a esta espina externa (padre)?
  function belongsToSpine(row, spine) {
    return row.foris.some((f) => f.firstSpine && arraysEqual(f.firstSpine, spine))
  }
  // ¿Fila padre? (solo 1 [] y misma espina)
  function isParentRow(row, spine) {
    return row.foris.some((f) => f.depth === 1 && f.firstSpine && arraysEqual(f.firstSpine, spine))
  }
  // ¿Fila hija? (>= 2 [] y misma espina)
  function isChildRow(row, spine) {
    return row.foris.some((f) => f.depth >= 2 && f.firstSpine && arraysEqual(f.firstSpine, spine))
  }

  for (let idx = 0; idx < rows.length; idx++) {
    const row = rows[idx]

    // Copiar lo previo intacto
    if (cursor < row.start) {
      out += xml.slice(cursor, row.start)
      cursor = row.start
    }

    // Si no hay foris con espina externa, copiar la fila tal cual
    const firstWithSpine = row.foris.find((f) => f.firstSpine)
    if (!firstWithSpine) {
      out += row.xml
      cursor = row.end
      continue
    }

    const groupSpine = firstWithSpine.firstSpine // PADRE = PRIMERA []
    // Reunir filas consecutivas que comparten la espina externa
    const group = [row]
    let j = idx + 1
    while (j < rows.length && belongsToSpine(rows[j], groupSpine)) {
      group.push(rows[j])
      j++
    }

    const baseArr = baseArrayFor(groupSpine)
    if (!baseArr || !baseArr.length) {
      // Sin datos del padre → no emitimos nada de este grupo (eliminamos plantillas)
      cursor = group[group.length - 1].end
      idx = j - 1
      continue
    }

    // Separar padres e hijos
    const parentRows = group.filter((r) => isParentRow(r, groupSpine))
    const childRows = group.filter((r) => isChildRow(r, groupSpine))

    // Generar bloque: por cada i del padre → padres(i) + hijos(i,*)
    let block = ''
    for (let i = 0; i < baseArr.length; i++) {
      const baseContext = baseArr[i]

      // 1) Filas padre (solo [i])
      for (const pr of parentRows) {
        block += replaceForiWithIndices(pr.xml, [i])
      }

      // 2) Filas hijo (para cada j en el primer array hijo después del padre)
      for (const cr of childRows) {
        // Tomar un fori representativo de esta fila (>= 2 [] y misma espina)
        const f = cr.foris.find(
          (ff) => ff.depth >= 2 && ff.firstSpine && arraysEqual(ff.firstSpine, groupSpine)
        )
        if (!f) continue

        const cinfo = childArrayInfo(f.parts)
        if (!cinfo) continue

        const childArr = resolveChildArray(baseContext, cinfo.between, cinfo.childKey)
        if (!Array.isArray(childArr) || !childArr.length) {
          // si no hay hijos, no añadimos filas (si quieres fila vacía, aquí es el sitio)
          continue
        }

        for (let jx = 0; jx < childArr.length; jx++) {
          // sustituimos dos niveles: [i] (padre) y [jx] (hijo)
          block += replaceForiWithIndices(cr.xml, [i, jx])
        }
      }
    }

    // Insertar bloque y saltar plantillas del grupo
    out += block
    cursor = group[group.length - 1].end
    idx = j - 1
  }

  // Copiar el resto
  if (cursor < xml.length) out += xml.slice(cursor)

  return out
}
